export default {
  COOKIES_ACCEPTED: 'cookiesAccepted',
};
